import React from "react";
import classnames from "classnames";
import { ReactComponent as ArrowUpPointy } from "images/ugg/icons/arrow-up-pointy.svg";
import { ReactComponent as ArrowDownPointy } from "images/ugg/icons/arrow-down-pointy.svg";

const ArrowButton = (props) => {
  const { toggleFunction, isOpen } = props;

  const toggle = () => {
    toggleFunction(!isOpen);
  };

  return (
    <div className={classnames({ button: true, "button-unclicked": !isOpen, "button-clicked": isOpen })} onClick={toggle}>
      {isOpen ? <ArrowUpPointy className="img" /> : <ArrowDownPointy className="img" />}
    </div>
  );
};

export default ArrowButton;
